import { PdfIcon } from '@/icons';
import { FileType } from '@/models/file.model';
import { ReactNode } from 'react';
import { getFileTypeByFormat } from './getFileTypeByFormat';

export const fileTypeIcon: Record<FileType, ReactNode> = {
  [FileType.PDF]: <PdfIcon />,
};

export const getFileIcon = (name: string): ReactNode => fileTypeIcon[getFileTypeByFormat(name)];
